<div class="review-dialog">
  <div class="review-header">
    <mat-icon class="review-icon">rate_review</mat-icon>
    <h2 class="review-title">Review Your Imported Form</h2>
  </div>

  <div class="review-body">
    <p class="review-text">
      This form was generated by AI from your uploaded document. AI can misread fields, labels, or
      logic — please review every paragraph and control before using this form with patients.
    </p>

    <div class="callout note-builder-callout" *ngIf="data.hasNoteBuilderItems">
      <mat-icon>description</mat-icon>
      <span>
        This form includes Note Builder logic. Verify that note triggers, linked answers, and the
        assembled note text are correct before publishing.
      </span>
    </div>

    <div class="callout review-callout">
      <mat-icon>fact_check</mat-icon>
      <span>
        Review the imported form carefully before publishing. Confirm every field, label, and
        control matches your original before using it with patients.
      </span>
    </div>
  </div>

  <div class="review-actions">
    <span class="spacer"></span>
    <button mat-raised-button color="accent" (click)="acknowledge()">
      <mat-icon>check</mat-icon>
      I Understand
    </button>
  </div>
</div>
